module.exports = __webpack_public_path__ + "img/Home_Tablet_04.f25a5497.jpg";